import {
  setFlightTimer,
  setRevalidateFlightData,
} from "@/feature/flight/checkout/state/revalidate.slice";
import { withQueryString } from "@/lib/api/api-helpers";
import { baseApi } from "@/redux/api/base-api";

import type {
  IFlightRevalidateApiResponse,
  IFlightRevalidateBookingApiResponse,
} from "../types/revalidate";

export type FlightRevalidateQueryArg = {
  searchId: string;
  flightId: string | number;
};

export const flightRevalidateApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getFlightRevalidate: builder.query<
      IFlightRevalidateApiResponse,
      FlightRevalidateQueryArg
    >({
      query: ({ searchId, flightId }) => ({
        url: withQueryString("/b2c/flight/revalidate", {
          search_id: searchId,
          flight_id: flightId,
        }),
        method: "GET",
      }),
      keepUnusedDataFor: 0,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const ttl = data?.data?.ttl;
          if (typeof ttl === "number" && ttl > 0) {
            dispatch(setFlightTimer(Date.now() + ttl * 1000));
          }
          if (data?.data) {
            dispatch(
              setRevalidateFlightData({
                data: data.data,
                searchId: String(arg.searchId),
              }),
            );
          }
        } catch {
          // Ignore - error handled by the component
        }
      },
    }),
    createFlightRevalidateBooking: builder.mutation<
      IFlightRevalidateBookingApiResponse,
      FormData
    >({
      query: (body) => ({
        url: "/b2c/flight/booking",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "FlightBookingList", id: "LIST" }],
    }),

    // ! make payment
    makePayment: builder.mutation<
      { success: boolean; redirect_url: string },
      { invoice_id: string | number; success_page: string; failed_page: string; cancelled_page: string; }

    >({
      query: (arg) => {
        const { invoice_id, ...body } = arg;
        return {
          url: `/b2c/payment/ssl/${invoice_id}`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: [{ type: "FlightBookingList", id: "LIST" }],
    }),
  }),
});

export const {
  useGetFlightRevalidateQuery,
  useLazyGetFlightRevalidateQuery,
  useCreateFlightRevalidateBookingMutation,
  useMakePaymentMutation,
} = flightRevalidateApi;
